module.exports = __webpack_public_path__ + "static/media/yellow.b66b6e98.JPG";